<div
  class="p-4 flex flex-col gap-y-4 basis-full flex-grow app-full-height items-stretch"
>
  <div class="flex flex-row justify-start items-center flex-grow-0">
    <h1 class="flex flex-grow basis-full">Customers</h1>
    <button
      mat-flat-button
      (click)="addCustomer()"
      color="primary"
      class="flex-shrink-0"
    >
      New Customer
    </button>
  </div>
  <div class="flex flex-grow-0 flex-row justify-start items-center">
    <mat-form-field class="flex-grow md:flex-grow-0 lg:w-1/2 w-full">
      <input
        matInput
        [formControl]="filter"
        placeholder="Filter customers"
        autofocus
      />
      <mat-hint
        >Search for customer by name, address, email or phone number
      </mat-hint>
    </mat-form-field>
  </div>
  <div class="flex flex-grow basis-full flex-col items-stretch justify-start">
    <ag-grid-angular
      #agGrid
      class="ag-theme-alpine h-full"
      [columnDefs]="columnDefinitions"
      [rowData]="filteredCustomers"
      [gridOptions]="gridOptions"
    ></ag-grid-angular>
  </div>
</div>
